module.exports = __webpack_public_path__ + "static/assets/96b4771af45da0218b3356d65c82870e.svg";